import { useCommunicationContext } from './CommunicationContext';

export const useCommunicationBanner = () => {
    const { banner, close, action } = useCommunicationContext();

    return { communication: banner, close, action };
};
